// Import select2
import select2 from 'select2';

// Hook up select2 to jQuery
select2($);